import {useAsyncRetry} from 'react-use';

import {getJob, getJobLog, getTaskResult} from '@/api/jobs';

export function useJobInfo(jobId) {
    return useAsyncRetry(async () => {
        if (!jobId) {
            return {data: null};
        }
        return await getJob(jobId);
    }, [jobId]);
}

export function useJobLogInfo(jobLogId) {
    return useAsyncRetry(async () => {
        if (!jobLogId) {
            return {data: null};
        }
        return await getJobLog(jobLogId);
    }, [jobLogId]);
}


export function useTaskResultInfo(id) {
    return useAsyncRetry(async () => {
        if (!id) {
            return {data: null};
        }
        return await getTaskResult(id);
    }, [id]);
}
